import { ReactComponent as ArrowUpIcon } from 'images/icons/ArrowUp.svg';
import { ReactComponent as CrownIcon } from 'images/icons/Crown.svg';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import utc from 'dayjs/plugin/utc';
import { formatTimeLength } from 'utilities/formatDate';
import { EventVideoThumbnail } from 'components/EventVideoThumbnail/EventVideoThumbnail';
import { EventPreviewImageUploader } from '../EventPreviewImageUploader/EventPreviewImageUploader';
import { AdminEventPlayerType, LocationType } from 'types/admin/trackmanEventsAdmin';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export const EventPreview = ({
  videoId,
  isPremiumEvent,
  videoLengthHours,
  videoLengthMinutes,
  title,
  startDate,
  recordingReady,
  locationType,
  location,
  playerType,
  previewImageData,
  setPreviewImageData,
}: {
  videoId?: string | null;
  isPremiumEvent: boolean;
  videoLengthHours?: string | null;
  videoLengthMinutes?: string | null;
  title: string;
  startDate: string;
  recordingReady: boolean;
  locationType: LocationType;
  location: string | null;
  playerType: AdminEventPlayerType;
  previewImageData: File | null;
  setPreviewImageData: (file: File | null) => void;
}) => {
  const timeInfo = startDate
    ? !recordingReady
      ? dayjs(startDate).tz(dayjs.tz.guess()).format('MMM DD, h:mma z')
      : `Streamed ${dayjs().diff(dayjs(startDate), 'days')} day(s) ago`
    : '[MMM DD, HH:mma]';

  const getLocationInfo = () => {
    if (locationType === 'Online') {
      return 'Online';
    }
    if (location) {
      return location;
    }
    return null;
  };
  return (
    <div className='admin-edit-section event-tile'>
      <h2>Preview</h2>
      {videoId ? (
        <EventVideoThumbnail
          videoId={videoId}
          thumbnailSize='hqdefault'
          badgeText={isPremiumEvent ? 'Premium' : ''}
          badgeIcon={isPremiumEvent ? <CrownIcon /> : null}
          playerType={playerType}
        />
      ) : (
        <EventPreviewImageUploader
          previewImageData={previewImageData}
          isEventPremium={isPremiumEvent}
          badgeText={isPremiumEvent ? 'Premium' : ''}
          badgeIcon={isPremiumEvent ? <CrownIcon /> : null}
          setPreviewImageData={setPreviewImageData}
        />
      )}
      <div className='event-info'>
        {!recordingReady && <h3>{getLocationInfo()}</h3>}
        <div className='time'>
          <span>
            {timeInfo} - {isPremiumEvent ? 'Paid' : 'Free'}
          </span>
          {videoLengthHours && videoLengthMinutes ? (
            <span className='video-length'>{formatTimeLength(`${videoLengthHours}:${videoLengthMinutes}:00`)}</span>
          ) : null}
        </div>
        <div className='event-title'>
          {title !== '' ? title : '[Event Title Event Title Event Title]'}
          <ArrowUpIcon />
        </div>
      </div>
    </div>
  );
};
